<template>
    <ad-form v-if="renewAdData"
                :allowed-image-types="allowedImageTypes"
                :max-file-size="maxFileSize"
                :offer="renewAdData"
                :save-handler="getHandleRenewAd"
                :locale="locale"></ad-form>
</template>

<script>
import AdForm from "../AdForm";
import AdsApi from "../../services/AdsApi";

export default {
    name: 'RenewAd',
    components: {AdForm},
    data() {
        return {
            renewAdData: null
        };
    },
    props: [
        'locale',
        'allowedImageTypes',
        'maxFileSize',
        'expiredAdId',
        'csrfToken'
    ],
    created() {
        AdsApi.getFullAdData(this.locale, this.expiredAdId).then((response) => {
            this.renewAdData = response.data;
        });
    },
    methods: {
        getHandleRenewAd(renewAdData) {
            return AdsApi.renewAd(renewAdData, this.locale, this.csrfToken).then(response => {
                return response.json();
            });
        }
    }
};
</script>

<style scoped>
</style>
